export default __webpack_public_path__ + "assets/images/import-info-image39581ea2389dc962b918f8cdceef38f4.png";